import { createSlice } from "@reduxjs/toolkit";

// define transaction form
export const initialTransactionForm = {
  client_name: "",
  date: "",
  source: "",
  amount: "",
  tags: [],
  payment_mode: "",
  note: "",
  transaction_status: "",
  address: "",
};

// define edit transaction form
export const initialEditTransaction = {
  client_name: "",
  date: "",
  source: "",
  amount: "",
  tags: [],
  payment_mode: "",
  note: "",
  transaction_status: "",
};

const initialState = {
  popup: {
    addTransactionPopup: false,
    editTransactionPopup: false,
    deleteTransactionPopup: false,
  },
  form: {
    transactionForm: initialTransactionForm,
    addTransactionComponent: 1,
    editTransactionForm: initialEditTransaction,
  },
  other:{
    transaction_id:null
  }
};

const addTransactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    // dispatch action for popup
    openAddTransactionPopup: (state) => {
      state.popup.addTransactionPopup = true;
    },
    closeAddTransactionPopup: (state) => {
      state.popup.addTransactionPopup = false;
    },
    openEditTransactionPopup: (state, action) => {
      state.popup.editTransactionPopup = true;
      state.form.editTransactionForm = action.payload
    },
    closeEditTransactionPopup: (state) => {
      state.popup.editTransactionPopup = false;
      state.form.editTransactionForm = initialEditTransaction
    },
    openDeleteTransactionPopup: (state, action) => {
      state.popup.deleteTransactionPopup = true;
      state.other.transaction_id= action.payload
    },
    closeDeleteTransactionPopup: (state) => {
      state.popup.deleteTransactionPopup = false;
      state.other.transaction_id= null
    },

    // dispatch action for form
    addTransactionForm: (state, action) => {
        state.form.transactionForm=action.payload
    },
    editTransactionForm: (state, action) => {
        state.form.editTransactionForm=action.payload
    },
    addTransactionComponent: (state, action) => {
        state.form.addTransactionComponent=action.payload
    },
  },
});

export const { openAddTransactionPopup, closeAddTransactionPopup,openEditTransactionPopup,
closeEditTransactionPopup,openDeleteTransactionPopup, addTransactionForm, addTransactionComponent,
closeDeleteTransactionPopup, editTransactionForm
} = addTransactionSlice.actions;

// get popup state
export const getAddTransactionPopup = (state) => state.transaction.popup.addTransactionPopup;
export const getEditTransactionPopup = (state) => state.transaction.popup.editTransactionPopup;
export const getDeleteTransactionPopup = (state) => state.transaction.popup.deleteTransactionPopup;

// get form state
export const getTransactionForm = (state) => state.transaction.form.transactionForm;
export const getEditTransactionForm = (state) => state.transaction.form.editTransactionForm;
export const getAddTransactionComponent = (state) => state.transaction.form.addTransactionComponent;

// get other state
export const getTransactionId = (state) => state.transaction.other.transaction_id;

export default addTransactionSlice.reducer;